export default __webpack_public_path__ + "static/media/excellent.a1de4b72.svg";